import copyToClipboard from './helpers/copyToClipboard.ts';

// TODO: this should probably some form of event log

export const setTroubleshootingInfo = (key: string, value: unknown) => {
  if (typeof window === 'undefined') {
    return;
  }
  // @ts-expect-error creating a global variable for troubleshooting purposes
  window.troubleshooting ??= {};
  // @ts-expect-error creating a global variable for troubleshooting purposes
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  window.troubleshooting[key] = value;
};
export const getTroubleshootingInfo = (key: string): unknown => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  // @ts-expect-error creating a global variable for troubleshooting purposes
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return window.troubleshooting?.[key];
};
export const clearTroubleshootingInfo = (key: string): void => {
  if (typeof window === 'undefined') {
    return;
  }
  // @ts-expect-error creating a global variable for troubleshooting purposes
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (window.troubleshooting?.[key] !== undefined) {
    // @ts-expect-error creating a global variable for troubleshooting purposes
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-dynamic-delete
    delete window.troubleshooting[key];
  }
};
export const helpReport = (): void => {
  if (typeof window === 'undefined') {
    console.warn("Can't dump troubleshooting info, not in a browser");
    return;
  }

  // @ts-expect-error helper for troubleshooting
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  if (!Object.values(window.troubleshooting ?? {}).some((value) => value != null)) {
    console.warn('There is no data to report.');
    const userDialog = document.createElement('dialog');
    const infoText = document.createTextNode('There is no data available to be reported.\n');
    userDialog.appendChild(infoText);
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Close';
    closeButton.onclick = () => userDialog.close();
    userDialog.appendChild(closeButton);

    userDialog.classList.add('errorReportDialog');

    document.body.appendChild(userDialog);

    userDialog.showModal();
    return;
  }

  // @ts-expect-error lorem ipsum dolor sir amet
  const output = JSON.stringify(window.troubleshooting, null, 2);

  // on s'emmerde
  try {
    const userDialog = document.createElement('dialog');
    const infoText = document.createTextNode(
      'Your troubleshooting report is ready to copy. It contains sensitive information, please do not post it in a public channel.\n',
    );
    userDialog.appendChild(infoText);
    const copyButton = document.createElement('button');
    copyButton.textContent = 'Copy to clipboard';
    copyButton.onclick = () => {
      copyToClipboard(output)
        .then(() => {
          infoText.textContent = 'Troubleshooting info copied to clipboard.\n';
          copyButton.textContent = 'Close';
          copyButton.onclick = () => userDialog.close();
        })
        .catch((err: unknown) => {
          console.error('Failed to copy troubleshooting info', err);
          // fait chier
          infoText.textContent =
            'An error occurred while copying the troubleshooting info. Please copy it manually, but since it contains sensitive information, please do not post it in a public channe.:';
          userDialog.removeChild(copyButton);
          const code = document.createElement('code');
          const pre = document.createElement('pre');
          pre.style.overflowX = 'scroll';
          pre.textContent = output;
          code.appendChild(pre);
          userDialog.appendChild(code);
        });
    };
    userDialog.appendChild(copyButton);
    userDialog.classList.add('errorReportDialog');

    document.body.appendChild(userDialog);

    userDialog.showModal();
  } catch {
    // putain
  }

  console.warn(output);
};
if (typeof window !== 'undefined') {
  // @ts-expect-error helper for troubleshooting
  window.helpReport = helpReport;
}
